import { React, useState } from "react";
import { Form, FloatingLabel } from "react-bootstrap";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import eyeImg from "../assets/images/viewIcon.png";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotPassword({ setIsLoggedIn }) {
  const [userDetails, setUserDetails] = useState({
    email: "",
    otp: "",
    password: "",
    cpassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [validated, setValidated] = useState(false);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [showOtpBox, setShowOtpBox] = useState(false);

  const [err, setErr] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSendOtp = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true)

    const payload = {
      email: userDetails.email,
    };

    AuthService.generateOTP(payload)
      .then((resp) => {
        // console.log(resp);
        if (resp.data.flag === 1) {
          setLoading(false);
          toast.success(resp.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setShowOtpBox(true);
        }
      })
      .catch((e) => console.log(e));
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const payload = {
      username: userDetails.email,
      newpasswrd: userDetails.password,
      otp: userDetails.otp,
    };

    // console.log(userDetails);

    if (userDetails.password === userDetails.cpassword) {
      AuthService.changePassword(payload)
        .then((resp) => {
          if (resp.data.success) {
            toast.success(resp.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              onClose: () => navigate("/"),
            });
            
          } else {
            toast.warn(resp.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          toast.warn(e.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    } else {
      toast.warn("Password and Confirm Password are not matching!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

   const handleShowCPassword = () => {
    setShowCPassword(!showCPassword);
  };

  return (
    <div>
      <div className="login-main-container">
        <div className="login-container">
          <div className="login-form">
            <div className="login-heading">
              <h2>{showOtpBox ? "Change Password" : "Forgot Password"}</h2>
            </div>
            <ToastContainer />
            <div>
              <div className="invalid-deets text-start">{err}</div>
              {showOtpBox ? (
                <>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleVerifyOtp}
                  >
                    <div className="row">
                      <div className="col-12 col-sm-12 col-lg-12 mb-2">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Email ID"
                            className="mb-3"
                          >
                            <Form.Control
                              type="email"
                              required
                              placeholder="name@example.com"
                              name="email"
                              value={userDetails.email}
                              readOnly
                            />
                            <Form.Control.Feedback
                              type="invalid"
                              className="text-start"
                            >
                              Please provide Email Id.
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </div>
                      <div className="col-12 col-sm-12 col-lg-12 mb-2">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="OTP"
                            className="mb-3"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="otp"
                              value={userDetails.otp}
                              onChange={handleChange}
                            />
                          </FloatingLabel>
                        </Form.Group>
                      </div>
                      <div className="col-12 col-sm-12 col-lg-12 mb-2 showPassword">
                        <FloatingLabel
                          controlId="floatingPassword"
                          label="Password"
                        >
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            required
                            placeholder="Password"
                            name="password"
                            value={userDetails.password}
                            onChange={handleChange}
                            autocomplete="off"
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="text-start"
                          >
                            Please provide Password.
                          </Form.Control.Feedback>
                        </FloatingLabel>
                        {userDetails.password ? (
                          <div onClick={handleShowPassword}>
                            <img
                              className="showPasswordImg"
                              width="18px"
                              src={eyeImg}
                              alt="img"
                            />
                            {showPassword ? (
                              <div className="fwd-slash"></div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="col-12 col-sm-12 col-lg-12 mb-2 showPassword">
                        <FloatingLabel
                          controlId="floatingPassword"
                          label="Confirm Password"
                        >
                          <Form.Control
                            type={showCPassword ? "text" : "password"}
                            required
                            placeholder="Password"
                            name="cpassword"
                            value={userDetails.cpassword}
                            onChange={handleChange}
                            autocomplete="off"
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="text-start"
                          >
                            Please provide Password.
                          </Form.Control.Feedback>
                        </FloatingLabel>
                        {userDetails.password ? (
                          <div onClick={handleShowCPassword}>
                            <img
                              className="showPasswordImg"
                              width="18px"
                              src={eyeImg}
                              alt="img"
                            />
                            {showCPassword ? (
                              <div className="fwd-slash"></div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <div className="login-btn">
                      <button>Submit</button>
                    </div>
                  </Form>
                </>
              ) : (
                <>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSendOtp}
                  >
                    <div className="row">
                      <div className="col-12 col-sm-12 col-lg-12 mb-5">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Email ID"
                            className="mb-3"
                          >
                            <Form.Control
                              type="email"
                              required
                              placeholder="name@example.com"
                              name="email"
                              value={userDetails.email}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback
                              type="invalid"
                              className="text-start"
                            >
                              Please provide Email Id.
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="login-btn">
                      <button disabled={loading}>
                        {loading ? "Sending..." : "Send OTP"}
                      </button>
                    </div>
                  </Form>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="login-greeting d-flex flex-column gap-5">
          <h1>Welcome Back!</h1>
          <h4>
            Forgot your password. Don't worry. Enter your email address and get
            otp to chnage your password!
          </h4>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
